export const PRODUCT_TYPE_GET ="/ProductType/GetAllProductType"
